import React, { useState, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import type { EditorConfig } from '@ckeditor/ckeditor5-core';
 

interface EditorProps {
    name: string;
    defaultValue?: string;
    placeholders?: string[];
}

// By explicitly defining the configuration type, we can avoid TypeScript errors
// that may arise from module resolution issues (e.g., duplicate packages in node_modules)
// which can prevent automatic type augmentation from working correctly.
interface MyEditorConfig extends EditorConfig {
    mention?: {
        feeds: {
            marker: string;
            feed: { id: string; text: string; }[];
            minimumCharacters?: number;
        }[];
    };
}

const Editor = ({ name, defaultValue = '', placeholders = [] }: EditorProps) => {
    const [data, setData] = useState(defaultValue);

    useEffect(() => {
        setData(defaultValue);
    }, [defaultValue]);

    const editorConfiguration: any = {
        licenseKey:"GPL",  
        mention: {
            feeds: [
                {
                    marker: '@',
                    feed: placeholders.map(placeholder => ({ id: `@${placeholder}`, text: `[${placeholder}]` })),
                    minimumCharacters: 0
                }
            ]
        }
    };

    return (
        <div>
            {placeholders.length > 0 && <div className='flex flex-wrap gap-3'>
                <div>Used Data keys: </div>
            {                
                placeholders.map(placeholder => (<div key={placeholder} className=' '>{"{{"+placeholder+"}}"}</div>))
            }
            </div>}
            <CKEditor
          
                editor={ClassicEditor}
                config={editorConfiguration}
                data={data}
                onChange={(event, editor) => {
                    setData(editor.getData());
                }}
            />
            <textarea name={name} value={data} readOnly style={{ display: 'none' }} />
        </div>
    );
};

export default Editor;
